
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'

export default {
  inject: ['info'],
  props: {
    title: {
      type: String,
      default: ''
    },
    title2: {
      type: String,
      default: ''
    },
    titlesize: {
      type: String,
      default: ''
    },
    noline: {
      type: String,
      default: ''
    },
    elementtype: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    postion: {
      type: String,
      default: ''
    },
    show: {
      type: String,
      default: ''
    },
    spindex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showArrow: this.show == '1'
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == this.postion || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('文字版交易商标题(m版)')
  },
  methods: {
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    },
    changeTextTraderArrow() {
      this.showArrow = !this.showArrow
      bus.$emit('TextTraderArrow', {
        pos: this.postion,
        show: this.showArrow
      })
    }
  }
}
